import { FilterReportVocEmission } from "src/entity/waste-water/report-voc-emission.entity";
import {
  calculateReportVocAfterRejectApproval,
  calculateReportVocAfterUpdateMasterWW,
  calculateReportVocWasteWater,
  getFilterColumnWWReportVocEmission,
  searchWWReportVocEmission,
} from "src/services/waste-water.service";
import { create } from "zustand";
import { WWReportStoreProps } from "./interface/ww-report-store.interface";

const getInitialFilter = () => ({
  wasteWaterUnit: [],
  area: [],
});

export const reportWasteWaterStore = create<WWReportStoreProps>((set) => ({
  loadingAll: false,
  loadingGetVoc: false,
  dataReportVoc: {
    total: 0,
    data: [],
    summary: [],
  },
  erroVoc: null,

  loadingGetMaster: false,
  filterReportVocEmission: {
    wasteWaterUnit: [],
    area: [],
  },
  loadingCalculateReport: false,
  clearError: (type: string) => {
    set(() => ({ [`${type}`]: null }));
  },
  setLoadingAll: (loading: boolean) => {
    set(() => ({ loadingAll: loading }));
  },

  searchReportVocEmission: async (filter: FilterReportVocEmission) => {
    set(() => ({ loadingGetVoc: true }));
    try {
      const res = await searchWWReportVocEmission(filter);
      set(() => ({ loadingGetVoc: false, dataReportVoc: res.data?.data }));
    } catch (err: any) {
      set(() => ({ loadingGetVoc: false, error: err?.message, dataReportVoc: { data: [], total: 0, summary: [] } }));
    }
  },
  getFilterColumnReportVocEmission: async (year: string) => {
    set(() => ({ loadingGetMaster: true }));
    try {
      const res = await getFilterColumnWWReportVocEmission({ year });
      set(() => ({
        loadingGetMaster: false,
        filterReportVocEmission: res.data?.data,
      }));
    } catch (err: any) {
      set(() => ({
        loadingGetMaster: false,
        filterReportVocEmission: getInitialFilter(),
      }));
    }
  },
  calculateReportVocWasteWater: async (_id: string) => {
    set(() => ({ loadingCalculateReport: true }));
    try {
      await calculateReportVocWasteWater(_id);
      set(() => ({
        loadingCalculateReport: false,
      }));
    } catch (err: any) {
      set(() => ({
        loadingCalculateReport: false,
      }));
    }
  },
  calculateReportVocAfterRejectApproval: async (year: string) => {
    set(() => ({ loadingCalculateReport: true }));
    try {
      await calculateReportVocAfterRejectApproval(year);
      set(() => ({
        loadingCalculateReport: false,
      }));
    } catch (err: any) {
      set(() => ({
        loadingCalculateReport: false,
      }));
    }
  },
  calculateReportVocAfterUpdateMasterWW: async (_id: string) => {
    set(() => ({ loadingCalculateReport: true }));
    try {
      await calculateReportVocAfterUpdateMasterWW(_id);
      set(() => ({
        loadingCalculateReport: false,
      }));
    } catch (err: any) {
      set(() => ({
        loadingCalculateReport: false,
      }));
    }
  },
}));
